import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toolsAPI } from '../../services/api';

// Асинхронные экшены
export const fetchTools = createAsyncThunk(
  'tools/fetchTools',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await toolsAPI.getAll(params);
      return {
        data: response.data,
        params
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchToolById = createAsyncThunk(
  'tools/fetchToolById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await toolsAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const toolsSlice = createSlice({
  name: 'tools',
  initialState: {
    items: [],
    selectedTool: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 1
    }
  },
  reducers: {
    updateTool: (state, action) => {
      const tool = action.payload;
      const index = state.items.findIndex(item => item.id === tool.id);

      if (index !== -1) {
        state.items[index] = {
          ...state.items[index],
          ...tool,
        };
      } else {
        state.items.push(tool);
      }

      if (state.selectedTool && state.selectedTool.id === tool.id) {
        state.selectedTool = {
          ...state.selectedTool,
          ...tool,
        };
      }
    },

    deleteTool: (state, action) => {
      const id = action.payload;
      const idStr = id?.toString();

      if (!idStr) {
        console.error('Редьюсер: получен пустой ID для удаления инструмента');
        return;
      }

      state.items = state.items.filter(item => {
        const itemId = item.id?.toString();
        return itemId !== idStr;
      });

      if (state.selectedTool && state.selectedTool.id?.toString() === idStr) {
        state.selectedTool = null;
      }
    },

    resetSelectedTool: (state) => {
      state.selectedTool = null;
    },

    setPagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTools.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTools.fulfilled, (state, action) => {
        const { data, params } = action.payload;

        if (data && data.data && Array.isArray(data.data)) {
          state.items = data.data;

          if (data.pagination) {
            state.pagination = {
              page: params.page || 1,
              limit: params.limit || 10,
              total: data.pagination.total || 0,
              pages: Math.ceil(data.pagination.total / (params.limit || 10)) || 1
            };
          }
        } else if (Array.isArray(data)) {
          state.items = data;
          state.pagination = {
            ...state.pagination,
            total: data.length,
            pages: Math.ceil(data.length / (params.limit || 10)) || 1
          };
        }

        state.loading = false;
      })
      .addCase(fetchTools.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить инструменты';
      })

      .addCase(fetchToolById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchToolById.fulfilled, (state, action) => {
        state.selectedTool = action.payload;
        state.loading = false;
      })
      .addCase(fetchToolById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить инструмент';
      });
  },
});

// Экспорт экшенов
export const {
  updateTool,
  deleteTool,
  resetSelectedTool,
  setPagination
} = toolsSlice.actions;

// Селекторы
export const selectAllTools = (state) => state.tools.items;
export const selectSelectedTool = (state) => state.tools.selectedTool;
export const selectToolsLoading = (state) => state.tools.loading;
export const selectToolsError = (state) => state.tools.error;
export const selectToolsPagination = (state) => state.tools.pagination;

// Экспорт редьюсера
export default toolsSlice.reducer;
